import { render, staticRenderFns } from "./AddWordList.vue?vue&type=template&id=03503d52&"
import script from "./AddWordList.vue?vue&type=script&lang=js&"
export * from "./AddWordList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddWordList.vue"
export default component.exports